import { gradeFilterFactory } from '@/catalog/constants/filterInputMeta/gradeFilterFactory';

export default gradeFilterFactory({
  id: 'scintillation.gmc',
  name: 'Scintillation',
  setter(value, filters) {
    return filters.setScintillationGmc(value);
  },
  getter(filters) {
    return filters.scintillationGmc;
  },
});
